import { displayDateTime } from "./dateTime";

// Message for a failed save on the organiser/admin screens (event, rules,
// lots, bidders). The server's own text is shown when it gives one: its
// checks now say which field is wrong in plain words.

export const OFFLINE_MESSAGE = "Not saved. Check your internet.";
export const NO_PERMISSION_MESSAGE = "You don't have permission to do this.";
export const NOT_SAVED_MESSAGE = "Not saved. Please try again.";

const serverText = (data) => {
  const text = typeof data === "string" ? data : data?.error || data?.message;
  return typeof text === "string" ? text.trim() : "";
};

// error: what axios threw; fallback: shown when the server gives no reason
export const saveErrorMessage = (error, fallback = NOT_SAVED_MESSAGE) => {
  const response = error?.response;
  if (!response) return OFFLINE_MESSAGE;

  const text = serverText(response.data);
  if (response.status === 403 && !text) return NO_PERMISSION_MESSAGE;
  // a server fault's own text is technical
  if (response.status >= 500) return fallback;
  return text || fallback;
};

// The publish date and time can't be after bidding starts. Both times are
// shown, so a same-day mistake (publish 11:00 AM, bidding 10:00 AM) is clear.
// Returns null when the order is fine or a value is missing.
export const publishAfterBiddingStartMessage = (publish, biddingStart) => {
  if (!publish || !biddingStart) return null;
  const publishMs = new Date(publish).getTime();
  const startMs = new Date(biddingStart).getTime();
  if (!Number.isFinite(publishMs) || !Number.isFinite(startMs)) return null;
  if (publishMs <= startMs) return null;
  return `Publish date and time (${displayDateTime(
    publishMs
  )}) must be on or before the bidding start date and time (${displayDateTime(
    startMs
  )}).`;
};
